import { questionGenerator } from '@/data/generators/questionGenerator';
import { OrderingItem } from '@/models/Answer';
import { FlowColumn } from '@/models/DNDOrdenation';
import {
  DNDOrdenationQuestion,
  OrderingColumn,
  QuestionTypeEnum,
} from '@/models/Question';

export function orderingItemGenerator(
  item?: Partial<OrderingItem>,
): OrderingItem {
  return {
    id: 1,
    text: 'Item A',
    altText: '',
    mediaFile: null,
    order: 1,
    validPositions: [1],
    dndOrdenationColumn: 1,
    ...item,
  };
}

export function orderingColumnGenerator(
  column?: Partial<OrderingColumn>,
): OrderingColumn {
  return {
    id: 1,
    name: 'default',
    flow: FlowColumn.VERTICAL,
    items: [],
    ...column,
  };
}

export function orderingQuestionGenerator(
  question?: Partial<DNDOrdenationQuestion>,
): DNDOrdenationQuestion {
  return {
    ...questionGenerator(question),
    columns: [],
    ...question,
    type: QuestionTypeEnum.DND_ORDENATION,
  };
}
